export const regions = ['oceania', 'europe', 'asia', 'africa', 'americas', 'australia'];

export const agencyPreferenceKeys = ['PRIORITIZE', 'EXCLUDE', 'NO_PREFERENCE'];
export const agencyPreferenceValues = {
    PRIORITIZE: 'PRIORITIZE',
    EXCLUDE: 'EXCLUDE',
    NO_PREFERENCE: null,
};

export const minLevelKeys = ['ANY_LEVEL', 'LEVEL_ONE', 'LEVEL_TWO', 'LEVEL_TRS'];
export const minLevelValues = {
    ANY_LEVEL: null,
    LEVEL_ONE: 'LEVEL_ONE',
    LEVEL_TWO: 'LEVEL_TWO',
    LEVEL_TRS: 'LEVEL_TRS',
};
export const minLevelTooltip = {
    LEVEL_ONE: {
        level: 'Level 1',
        rating: 4.4,
        response_rate: '80%',
        orders: 5,
        clients: 3,
        earned: '$400',
    },
    LEVEL_TWO: {
        level: 'Level 2',
        rating: 4.6,
        response_rate: '90%',
        orders: 20,
        clients: 10,
        earned: '$2,000',
    },
    LEVEL_TRS: {
        level: 'Top Rated',
        rating: 4.7,
        response_rate: '90%',
        orders: 40,
        clients: 20,
        earned: '$10,000',
    },
};

export const timezones = [
    'Africa/Cairo',
    'Africa/Johannesburg',
    'America/Argentina/Buenos_Aires',
    'America/Chicago',
    'America/Los_Angeles',
    'America/New_York',
    'America/Sao_Paulo',
    'Asia/Amman',
    'Asia/Baghdad',
    'Asia/Bangkok',
    'Asia/Beirut',
    'Asia/Dubai',
    'Asia/Hong_Kong',
    'Asia/Jakarta',
    'Asia/Jerusalem',
    'Asia/Karachi',
    'Asia/Kolkata',
    'Asia/Seoul',
    'Asia/Shanghai',
    'Asia/Singapore',
    'Asia/Taipei',
    'Asia/Tashkent',
    'Asia/Tokyo',
    'Asia/Yangon',
    'Australia/Brisbane',
    'Australia/Melbourne',
    'Australia/Sydney',
    'Europe/Amsterdam',
    'Europe/Athens',
    'Europe/Berlin',
    'Europe/Istanbul',
    'Europe/London',
    'Europe/Madrid',
    'Europe/Moscow',
    'Europe/Paris',
    'Europe/Prague',
    'Europe/Rome',
    'Europe/Stockholm',
    'Europe/Vienna',
    'Pacific/Auckland',
    'Pacific/Fiji',
    'Pacific/Honolulu',
];

export const T_IDEAL_CANDIDATE_PREFIX = 'dm_brief_creation.sections.ideal_candidate';
export const T_LANGUAGE_PREFIX = `${T_IDEAL_CANDIDATE_PREFIX}.languages`;
export const T_LOCATION_PREFIX = `${T_IDEAL_CANDIDATE_PREFIX}.location_timezone.location`;
export const T_TIMEZONE_PREFIX = `${T_IDEAL_CANDIDATE_PREFIX}.location_timezone.timezone`;
export const T_FREELANCER_TYPE_PREFIX = `${T_IDEAL_CANDIDATE_PREFIX}.type_level`;
